import { useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import useClickOutside from '@/hooks/useClickOutside';
import { TOAST_TRANSITION } from '@/components/OrderToastStack/toastMotion';
import { NotificationBell } from './components/NotificationBell/NotificationBell';
import { NotificationPanel } from './components/NotificationPanel/NotificationPanel';
import { useNotificationCenter } from './hooks/useNotificationCenter';
import styles from './notificationCenter.module.scss';

/**
 * Центр уведомлений в шапке: колокольчик с бейджем непрочитанных и панель-
 * история. Состояние и логика — в `useNotificationCenter`, компонент «тупой».
 */
export const NotificationCenter: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    isOpen,
    notifications,
    unreadCount,
    hasUnread,
    toggle,
    close,
    handleSelect,
    handleMarkAllRead,
    handleClearAll
  } = useNotificationCenter();

  useClickOutside(containerRef, close);

  return (
    <div className={styles['notification-center']} ref={containerRef}>
      <NotificationBell
        count={unreadCount}
        isActive={isOpen}
        onClick={toggle}
      />

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className={styles['notification-center__popover']}
            initial={{ opacity: 0, y: -8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.98 }}
            transition={TOAST_TRANSITION}
          >
            <NotificationPanel
              notifications={notifications}
              hasUnread={hasUnread}
              onSelect={handleSelect}
              onMarkAllRead={handleMarkAllRead}
              onClearAll={handleClearAll}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
